var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('span',{class:_vm.className},[_c('span',{staticClass:"o-deco__inner"},[_c('icon',{attrs:{"icon":("field-" + _vm.field)}}),(_vm.ball)?_c('span',{staticClass:"o-deco__ball"}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }